/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import {initAmplitude, trackPageView} from './src/utils/amplitude'

// Redirect apex domain (hanshelse.no) to www subdomain
export const onClientEntry = () => {
  if (window.location.hostname === 'hanshelse.no') {
    window.location.replace(
      'https://www.hanshelse.no' + window.location.pathname + window.location.search
    )
  }

  initAmplitude()
}

export const onRouteUpdate = ({location}) => {
  trackPageView(location.pathname)
}
